const initialState = {
  fetching: false,
};

export default function therapistReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'ALL_THERAPIST':
      return { ...currentState, list: action.payload };
    case 'THERAPIST_ASSIGNING':
      return { ...currentState, fetching: true };
    case 'THERAPISTS_FETCHING':
      return { ...currentState, fetching: true };
    case 'FETCHING_ASSIGNED_USERS':
      return { ...currentState, fetching: true };
    case 'THERAPIST_ASSIGNED':
      return { ...currentState, selectedTherapist: action.payload.data, fetching: false };
    case 'THERAPISTS_FETCHED':
      return { ...currentState, allTherapists: action.payload.data, fetching: false };
    case 'THERAPISTS_RESET':
      return {
        ...currentState, allTherapists: action.payload.data, assignedUsers: null, fetching: false,
      };
    case 'FETCHED_ASSIGNED_USERS':
      return { ...currentState, assignedUsers: action.payload.data, fetching: false };
    case 'FETCHING_THERAPIST':
      return { ...currentState, fetching: true };
    case 'FETCHED_THERAPIST':
      return { ...currentState, fetching: false, therapists: action.payload.data };
    default:
      return currentState;
  }
}
